import React,{useEffect} from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { Link, useSearchParams } from "react-router-dom";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useSelector,useDispatch } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function ListDataUser({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
  listLoading,
}) {
  const dispatch = useDispatch();
  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(list);

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const commonItems = [{ label: "USERS", link: "" }];
  useEffect(() => {
    dispatch(setBreadCrumb(commonItems));
  }, []);

  return (
    <div className="pt-2">
      <div className="flex flex-wrap gap-2 mb-1 items-center">
        {checkAccess("User", "user-create") && (
          <Link to="/dashboard/users/create">
            <button
              className="p-2 bg-red text-white uppercase rounded-md"
              onClick={addData}
            >
              Add New User +
            </button>
          </Link>
        )}
        <Search searchKey={["name", "email"]} />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 lg:hidden block">{`Slide / scroll to right >`}</p>
      <div
        className={`grid justify-items-center grid-cols-table-4 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {list.length <= 0 && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-4">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!list.length <= 0 && <NoDataFound />}
        {currentList.map((title, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />
            <p className="uppercase">{title.name}</p>
            <p className="text-slate-600 uppercase">{title.email}</p>

            <div className="flex gap-3 min-w-fit ">
              {checkAccess("User", "user-edit") ? (
                <button
                  className={
                    listLoading || currentList?.length <= 0
                      ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                      : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                  }
                  onClick={() => editData(title.id)}
                  disabled={
                    loading.edit || listLoading || currentList?.length <= 0
                  }
                >
                  {loading.edit && loading.loadingId === title.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <CiEdit size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <button className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                  --
                </button>
              )}
              {checkAccess("User", "user-edit") ? (
                <button
                  className={
                    listLoading || currentList?.length <= 0
                      ? "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red opacity-50"
                      : "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                  }
                  onClick={() =>
                    deleteData((oldState) => ({ open: true, id: title.id }))
                  }
                  disabled={
                    loading.delete || listLoading || currentList?.length <= 0
                  }
                >
                  {loading.delete && loading.loadingId === title.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <MdDeleteOutline size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <button className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                  --
                </button>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-4 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}
